import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getFbData } from '../redux/actions/fbdata';
import { fireDir } from "./../firebase"
import { setSpinner } from '../redux/actions/spinner';

export type FirebaseData = {
  fetchInProgress: boolean,
  userAuthenticated?: boolean,
  config?: any,
  error?:string
}

export const useFirebaseData = (apikey?: string) => {
  const dispatch = useDispatch();
  const [firebaseData, setFirebaseData] = useState({ fetchInProgress: true } as FirebaseData)
  useEffect(() => {
    if (apikey) {
      setFirebaseData({ fetchInProgress: true });
      fireDir
        .doc(apikey)
        .get()
        .then(entry => {
          let data = entry.data()
          if (data) {
            const unitType = data.lang === 'us' ? 'YARD' : 'METER' || 'METER';
            const useCustomApp = data.useCustomApp;
            const isDefault = data.includeLibraryImages === undefined ? false : !data.includeLibraryImages;
            
            const imageLibraryFilters = []

            for (const key in data) {
              if (Object.prototype.hasOwnProperty.call(data, key) && key.startsWith('fabricFilter')) {
                const element = data[key];
                imageLibraryFilters.push({
                  filterName: element,
                  filterKey: key
                })
              }
            }
            
            dispatch(getFbData({ ...data, unitType, useCustomApp, isDefault, imageLibraryFilters }))
            setFirebaseData({ userAuthenticated: true, fetchInProgress: false, config: { ...data, unitType, useCustomApp, isDefault } })
          } else {
            setFirebaseData({ fetchInProgress: false, error: "Api key is not valid" });
          }
          dispatch(setSpinner(false))
        }).catch(()=>{
          setFirebaseData({ fetchInProgress: false, error: "Api key is not valid" });
          dispatch(setSpinner(false))
        })
    }
  }, [apikey, dispatch]);
  return firebaseData;
}